 <!-- Sidebar Start -->
 <aside class="left-sidebar" id="sidebar">
  <!-- Sidebar scroll-->
  <div>
    <div class="brand-logo d-flex align-items-center justify-content-between">
      <div (click)="handleLogoClick($event)" 
       class="text-nowrap logo-img mobile-hideLogo"
       [class.cursor-pointer]="roleName === 'Host'"
       [style.cursor]="roleName === 'Host' ? 'pointer' : 'default'">
      <img src="assets\images\VisitorBridgeLogo (1).png" alt="Image" class="" />
  </div>
      <div class="close-btn d-xl-none d-block sidebartoggler cursor-pointer" id="sidebarCollapse" (click)="closeSidebar()">
        <i class="ti ti-x fs-6"></i>
      </div>
    </div>

    <!-- Hi, User -->
    <div class="d-none user-name-div mb-3">
      <p class="mb-0 text-center">Hi, {{ user?.firstName }}</p>
    </div>

    <!-- <div class="current-date p-2 text-center">
      <i class="ti ti-calendar"></i> {{ currentDate | date:'fullDate' }} | {{ currentDate | date:'shortTime' }}
    </div> -->

    <!-- Sidebar navigation-->
    <nav class="sidebar-nav scroll-sidebar" data-simplebar="" style="@media (max-width: 1200px) {padding-bottom: 24px;}">
      <ul id="sidebarnav">
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Scan_QR','LIST')">
          <a class="sidebar-link cursor-pointer" (click)="openScanner = true" (click)="closeSidebar()" aria-expanded="false">
            <i class="bi bi-qr-code-scan" title="Scan QR code"></i>
            <span class="hide-menu">Scan QR code</span>
          </a>
        </li>
        @if (constants.hasModulePermission('Todays_Visits','LIST')) {
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between" routerLink="/todays-visits" routerLinkActive="active"
            (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/lets-icons_time.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Todays Visits</span>
                <i class="upcoming counts ml-2">{{ todaysVisitsCount }}</i>
              </div>
            </div>
          </a>
        </li>
        }
        @if (constants.hasModulePermission('Location_Wise_Visitors','LIST')) {
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/location-wise-visitors']" [queryParams]="{ status: 'all-visitors' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
                <img src="assets/icons/solar_user-linear.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">All Visitors</span>
                <i class="upcoming counts ml-2">{{ AllVisitorStatusCounts.totalVisitors }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/location-wise-visitors']" [queryParams]="{ status: 'favourite-visitors' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
               <img src="assets/icons/hugeicons_favourite.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Favourite Visitors</span>
                <i class="favourite counts ml-2">{{ AllVisitorStatusCounts.favoriteVisitors }}</i>
              </div>
            </div>
          </a>
        </li>
        }
         <!-- <hr class="sidebar-bottom-divider" /> -->
         @if (constants.hasModulePermission('Visit','LIST')) {
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="manage-visits-title nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">MANAGE VISITS</span>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visit','LIST')">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/visit-list']" [queryParams]="{ status: 'Scheduled' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
                <img src="assets/icons/lets-icons_time.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Upcoming</span> 
                <i class="upcoming counts ml-2">{{ getCount('Scheduled') }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visit','LIST')">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/visit-list']" [queryParams]="{ status: 'Checked_In' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
                <img src="assets/icons/icon-park-outline_check-one.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Checked In</span> 
                <i class="checked-in counts ml-2">{{ getCount('Checked_In') }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visit','LIST')">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/visit-list']" [queryParams]="{ status: 'Pending_Approvals' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/Pending-icon.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Pending Approvals</span>
                <i class="pending counts ml-2">{{ getCount('Pending_Approvals') }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visit','LIST')">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/visit-list']" [queryParams]="{ status: 'Checked_Out' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/icon-park-outline_check-one.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Checked Out</span>
                <i class="completed counts ml-2">{{ getCount('Checked_Out') }}</i> 
              </div>            
            </div>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visit','LIST')">
         <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/visit-list']" [queryParams]="{ status: 'Cancelled' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/icon-park-outline_close-one.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Cancelled</span>
                <i class="cancelled counts ml-2">{{ getCount('Cancelled') }}</i>
              </div>             
            </div>
          </a>
        </li>

        <!-- Approval Requests -->
        <li class="sidebar-item" *ngIf="isManager && constants.hasModulePermission('Visit','LIST')">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/approval-requests']" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/Pending-icon.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Team Requests</span>
                <i class="pending counts ml-2">{{ pendingManagerCount }}</i>
              </div>
            </div>
          </a>
        </li>
       
        }

        @if (constants.hasModulePermission('Visitors','LIST')) {
           <hr class="sidebar-bottom-divider" />
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">Manage Visitors</span>
        </li>
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/manage-visitors']" [queryParams]="{ status: 'my-visitors' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
                <img src="assets/icons/solar_user-linear.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">My Visitors</span>
                <i class="upcoming counts ml-2">{{ AllVisitorStatusCounts.totalVisitors }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item">
           <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/manage-visitors']" [queryParams]="{ status: 'frequent-visitors' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
               <img src="assets/icons/akar-icons_arrow-repeat.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Frequent Visitors</span>
                <i class="completed counts ml-2">{{ AllVisitorStatusCounts.frequentVisitors  }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/manage-visitors']" [queryParams]="{ status: 'favourite-visitors' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
               <img src="assets/icons/hugeicons_favourite.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Favourite Visitors</span>
                <i class="favourite counts ml-2">{{ AllVisitorStatusCounts.favoriteVisitors  }}</i>
              </div>
            </div>
          </a>
        </li>
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="closeSidebar()" aria-expanded="false" 
          [routerLink]="['/manage-visitors']" [queryParams]="{ status: 'blacklisted-visitors' }" routerLinkActive="active">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex text-center">
                <img src="assets/icons/solar_user-block-line-duotone.png" />
              </span>
              <div class="bobble-align d-flex justify-content-between">
                <span class="hide-menu">Blacklisted Visitors</span>
                <i class="blocklisted counts ml-2">{{ AllVisitorStatusCounts.blacklistedVisitors }}</i>
              </div>
            </div>
          </a>
        </li>
      }
        <!-- admin menus -->
         @if (constants.hasModulePermission('Users','LIST')) {
          <!-- Manage Users -->
        <!-- <hr class="sidebar-bottom-divider" /> -->
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">Manage Users</span>
        </li>
         <li class="sidebar-item" *ngIf="constants.hasModulePermission('Users','LIST')">
          <a class="sidebar-link" routerLink="/users" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/userss.png" />
            <span class="hide-menu">Users</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Users','LIST')">
          <a class="sidebar-link" routerLink="/host-users" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/userss.png" />
            <span class="hide-menu">Hosts</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Users','LIST')">
          <a class="sidebar-link" routerLink="/visitors" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/reception.png" />
            <span class="hide-menu">Visitors</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Users','LIST')">
          <a class="sidebar-link" routerLink="/blacklist-requests" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/block-icon.svg" />
            <span class="hide-menu">Blacklist Requests</span>
          </a>
        </li>
      }
      
        <!-- admin menus -->
         @if (constants.hasModulePermission('Role','LIST')) {
          <!-- Manage Users -->
        <hr class="sidebar-bottom-divider" />
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">Manage Role</span>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Role','LIST')">
          <a class="sidebar-link" routerLink="/roles-permissions" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/permissions.png" />
            <span class="hide-menu">Role & Permissions</span>
          </a>
        </li>
      }

        <!-- Manage MasterData -->
        @if (constants.hasModulePermission('Company_Profile','LIST') || constants.hasModulePermission('Locations','LIST') || constants.hasModulePermission('Vehicle_Types','LIST') || constants.hasModulePermission('Visit_Purpose','LIST') || constants.hasModulePermission('ID_Proof_Type','LIST')) {
          <hr class="sidebar-bottom-divider" />
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">Masterdata</span>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Company_Profile','LIST')">
          <a class="sidebar-link" routerLink="/master-data/company-profile" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/company-profile.png" />
            <span class="hide-menu">Company Profile</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Locations','LIST')">
          <a class="sidebar-link" routerLink="/master-data/visit-locations" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/location.png" />
            <span class="hide-menu">Visit Locations</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Vehicle_Types','LIST')">
          <a class="sidebar-link" routerLink="/master-data/vehicle-types" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/vehicle.png" />
            <span class="hide-menu">Vehicle Types</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visit_Purpose','LIST')">
          <a class="sidebar-link" routerLink="/master-data/purpose-types" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/Purpose-icon.svg" />
            <span class="hide-menu">Purpose Types</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('ID_Proof_Type','LIST')">
          <a class="sidebar-link" routerLink="/master-data/id-proof-types" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/Id-icon.svg" />
            <span class="hide-menu">Id Proof Types</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visitor_Declaration','LIST')">
          <a class="sidebar-link" routerLink="/master-data/declaration" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/iconoir_privacy-policy (1).png" />
            <span class="hide-menu">Visitor Declaration</span>
          </a>
        </li>
          <li class="sidebar-item" *ngIf="constants.hasModulePermission('Training_Video','LIST')">
          <a class="sidebar-link" routerLink="/master-data/training-video" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/company-profile.png" />
            <span class="hide-menu">Training Video</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Blacklist_Reasons','LIST')">
          <a class="sidebar-link" routerLink="/master-data/blacklist-reasons" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/block-icon.svg" />
            <span class="hide-menu">Blacklist Reasons</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Blacklist_Reasons','LIST')">
          <a class="sidebar-link" routerLink="/master-data/visitor-assets" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/laptop-phone.svg" />
            <span class="hide-menu">Visitor Assets</span>
          </a>
        </li>
      }

      <!-- Reports -->
      @if (constants.hasModulePermission('Visits_Report', 'LIST') || constants.hasModulePermission('Visitors_Report', 'LIST') ) {
          <hr class="sidebar-bottom-divider" />
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">Reports</span>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visitors_Report','LIST')">
          <a class="sidebar-link" routerLink="/reports/visitors" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/gis_map-users.png" />
            <span class="hide-menu">Visitors</span>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visits_Report','LIST')">
          <a class="sidebar-link" routerLink="/reports/visits" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <img src="assets/icons/iconoir_privacy-policy (1).png" />
            <span class="hide-menu">Visits</span>
          </a>
        </li>
      }
      
        @if (constants.hasModulePermission('Notifications', 'LIST') || constants.hasModulePermission('Announcments', 'LIST') || constants.hasModulePermission('Visitor_Policies', 'LIST') ) {
        <hr class="sidebar-bottom-divider" />
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
          <span class="hide-menu text-muted">NOTICES</span>
        </li>
          <li class="sidebar-item" *ngIf="constants.hasModulePermission('Notifications','LIST')">
          <a class="sidebar-link justify-content-between" routerLink="/notifications" routerLinkActive="active" (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/mage_notification-bell.png" />
              </span>
              <span class="hide-menu">Notifications</span>
            </div>
          </a>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Announcments','LIST')">
          <a class="sidebar-link justify-content-between" routerLink="/notices/announcements" routerLinkActive="active" aria-expanded="false" (click)="closeSidebar()">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/hugeicons_marketing.png" />
              </span>
              <span class="hide-menu">Announcements</span>
            </div>
          </a>
        </li>
       
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Visitor_Policies','LIST')">
          <a class="sidebar-link justify-content-between cursor-pointer" routerLink="/notices/visitor-policies" routerLinkActive="active" aria-expanded="false" (click)="closeSidebar()">
            <div class="d-flex align-items-center gap-3" >
              <span class="d-flex">
                <img src="assets/icons/iconoir_privacy-policy (1).png" />
              </span>
              <span class="hide-menu">Visitor Policies</span>
            </div>
          </a>
        </li>
      }

       
        <hr class="sidebar-bottom-divider" />
        <li>
          <span class="sidebar-divider lg"></span>
        </li>
        <li class="nav-small-cap">
          <i class="ti ti-dots nav-small-cap-icon fs-5"></i>
          <span class="hide-menu text-muted">OTHER</span>
        </li>
        <li class="sidebar-item" *ngIf="constants.hasModulePermission('Setting','LIST') || constants.hasModulePermission('Sync_Calender_Setting','LIST') || constants.hasModulePermission('AutoComplete_Setting','LIST') || constants.hasModulePermission('User_Profile','LIST')">
          <a class="sidebar-link justify-content-between" routerLink="/settings" routerLinkActive="active" (click)="closeSidebar()"  aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/hugeicons_setting-07.png" />
              </span>
              <span class="hide-menu">Settings</span>
            </div>
          </a>
        </li>
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="logout()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3" >
              <span class="d-flex">
                <img src="assets/icons/hugeicons_logout-05.png" />
              </span>
              <span class="hide-menu">Logout</span>
            </div>
          </a>
        </li>
      
        <hr class="sidebar-bottom-divider" />
      </ul>
      <div class="powered-by-image poweredBy-mobile text-center p-3 d-none">
        <small class="fw-bold text-black me-2">Powered by</small>
        <img src="assets/images/dnvLogo.png" alt="DNV Logo" class="img-fluid dnv-img">
      </div>
    </nav>
    <div class="powered-by-image text-center p-3 poweredBy-desktop">
        <small class="fw-bold text-black me-2">Powered by</small>
        <img src="assets/images/dnvLogo.png" alt="DNV Logo" class="img-fluid dnv-img">
    </div>
  </div>
</aside>

<app-qr-scanner *ngIf="openScanner" (scanned)="handleScan($event)" />